// extracted by css-extract-rspack-plugin
export default {"imagePaginationContainer":"ImagePagination-module__imagePaginationContainer","imagePaginationIndex":"ImagePagination-module__imagePaginationIndex"};